export const MODAL_NAME = "editProjectSpecialNoteModal";
